import React from "react";
import { useTranslation } from "react-i18next";
import Block from "../../Block";
import FormGroup from "../../forms/FormGroup";
import FormRowCol from "../../forms/FormRowCol";
import Select from "../../forms/inputs/Select";
import CpmRangeTable from "../CpmRangeTable";

const formGroupWidthProps = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
};

export default function Billing({ getInputProps, formRefValues, formData }) {
  const { t } = useTranslation();

  return (
    <Block title={t("dataVendor.billing")}> 
      <FormGroup
        as={FormRowCol}
        {...formGroupWidthProps}
        label={t("dataVendor.billingModel")}
        placeholder={t("pleaseSelect")}
        {...getInputProps("billing_model")}
      >
        <Select isClearable={true}>
          <option value="flat" key="flat">
            {t("billing.flat")}
          </option>
          <option value="cpm" key="cpm">
            {t("billing.cpm")}
          </option>
          <option value="cpm_range" key="cpm_range">
            {t("billing.cpm_range")}
          </option>
        </Select>
      </FormGroup>
      {["cpm", "cpm_range"].includes(formData.billing_model) && (
        <>
          <FormGroup
            as={FormRowCol}
            {...formGroupWidthProps}
            label={t("dataVendor.max_users")}
            input="number"
            {...getInputProps("max_users")}
          />
          <FormRowCol {...formGroupWidthProps}>
            <CpmRangeTable
              {...getInputProps("cpm")}
              range={formData.billing_model === "cpm_range"}
            />
          </FormRowCol>
        </>
      )}
      {formData.billing_model === "flat" && (
        <FormGroup
          as={FormRowCol}
          {...formGroupWidthProps}
          label={t("dataVendor.flat_fee")}
          input="number"
          {...getInputProps("flat_fee")}
        />
      )}
    </Block>
  );
}
